/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCardEntry = {
    properties: {
        statistic: {
            type: 'Statistic',
            isRequired: true,
        },
        value: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
